// extracted by mini-css-extract-plugin
module.exports = {"container":"ZcNXf","dot":"_2voQa","small":"_32iHA","opacitychange":"_2rA_n"};